<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node), 'node-id-' + node.id]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-concierge-bell card-file-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">

      <div ref="displayStatHtml"></div>

      <div class="card-data">

        <div class="typing_delay clearfix mb-2 p-1 pl-3 pr-3" v-if="node.data.IsTypingOnDisplayChecked && node.data.templateName">
          <p class="typing_display float-left mb-0 p-0 pr-1">
            <img :src="baseUrl + 'assets/pre-loader/typing_on.gif'" height="9px" width="20px"> {{ typing_display }}
          </p>
          <p class="delay_time float-right mb-0" v-if="node.data.delayReplyFor">
            {{ node.data.delayReplyFor }} {{ sec }}
          </p>
        </div>

        <p class="text-center mb-2 postback_title" v-if="node.data.templateName">
          {{node.data.templateName}}
        </p>

        <div class="list-group mt-2">
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="getSelectedLabelTexts(node)">         
            <small class="text-muted">{{ labelNames }}</small>
            <p class="mb-0"> {{ getSelectedLabelTexts(node) }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.sequence && node.data.sequenceText">         
            <small class="text-muted">{{ sequenceName }}</small>
            <p class="mb-0"> {{ node.data.sequenceText }}</p>
          </span>
        </div>

      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div 
            class="output text-right" 
            v-for="output in outputs()"
            :ref="output.key === otnSingleOutputSequence ? 'otnSequenceOutput' : ''" 
            :key="output.key"
            :class="[toggleSpecificSocket(node), hasConnection(output) ? 'has-connection' : '']"
          >
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>

        <div class="input_content">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { lang } from '../../assets/lang'
import CONST_SOCKET from '../../const/socket'
import { templateComponentMethods, updateNodeConnections } from '../../functions/utils'

export default {
  name: 'OtnSingleTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    sec: lang.common_info_sec,
    baseUrl: window.xitFlowBuilderData.base_url,
    typing_display: lang.common_info_typing_display,
    templateName: lang.otn_single_template_template_name,
    labelNames: lang.otn_single_template_labels,
    sequenceName: lang.otn_single_template_sequence_name,
    otnSingleOutputSequence: CONST_SOCKET.OTN_SINGLE_OUTPUT_SEQUENCE,
  }),

  methods: {
    ...templateComponentMethods,

    getSelectedLabelTexts(node) {
      const labelIdTextsArray = node.data.labelIdTextsArray || []
      return labelIdTextsArray.join(', ')
    },

    toggleSpecificSocket(node) {
      const that = this
      if(this.$refs.otnSequenceOutput) {
        const element = that.$refs.otnSequenceOutput[0]
        if('newSequence' === node.data.sequence) {
          element.classList.remove('d-none')
          element.classList.add('d-block')
        } else {
          element.classList.remove('d-block')
          element.classList.add('d-none')
          setTimeout(function() {
            element.classList.remove('d-block')
            element.classList.add('d-none')
          }, 100)
        }
      }
    },
  },

  async mounted() {
    const result = await this.displayStat(this.$props.node)
    $(this.$refs.displayStatHtml).html(result)

    updateNodeConnections(this.$props.node)
  }
}
</script>

<style scoped>
.input_content { width:50% !important;}
.output_content{ width:50% !important;float:right !important;}
.card-sockets { padding: 5px 0 !important;}

.card-content { font-weight: 400;font-size:12px;}

.card-file-icon { font-size: 13px; }
.xit-fb-template.hasData { min-width: 250px !important; }
.otn_postback_title {
  margin-bottom: -8px;
  font-size: 20px;
  /*font-family: garamond;*/
  font-weight: 900;
}

.otn_postback_id { color:#8d8d8d;margin-bottom:5px;}
</style>